module.exports = __webpack_public_path__ + "static/media/copy-icon.30e6aa4a.svg";